import { WebOffer } from 'model/model.web-offer';
import Script from 'next/script';

type JobOfferJobPostingSchemaProps = {
  offer: WebOffer;
  locale?: string;
};

const JobOfferJobPostingSchema: React.FC<JobOfferJobPostingSchemaProps> = ({
  offer
}) => {
  return (
    // eslint-disable-next-line @next/next/no-before-interactive-script-outside-document
    <Script
      id="jobPostingSchema"
      strategy="beforeInteractive"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: offer.jsonld
      }}
    ></Script>
  );
};

export default JobOfferJobPostingSchema;
